module.exports = __webpack_public_path__ + "img/u38.4d53609d.png";